import React, { useState, useEffect } from "react";
import Header from "./Components/Header";
import Footer from "./Components/Footer";
import SocialMediaLinks from "./Components/SocialMediaLinks";
import Loader from "./Components/Loader";

const SocialMediaLinksPage=()=>{

       useEffect(()=>{
                    document.title="Instagram | Balaji Badminton Academy"
                  },[]);
    return(
        <>
            <Header/>
            <Loader/>
                <SocialMediaLinks/>
            <Footer/>
        </>
    );
}

export default SocialMediaLinksPage;